import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import type { PortalErrorKind } from '@erp/shared';
import { portalErrorPresentation, reportPortalError } from '@/lib/portal-diagnostics';
import { Button } from '@/components/ui/button';

export function PortalErrorNotice({
  error,
  kind,
  retry,
  count,
  targetId,
  action = 'view',
  correlationId,
}: {
  error: unknown;
  kind?: PortalErrorKind;
  retry?: () => void;
  count?: number;
  targetId?: string;
  action?: string;
  correlationId?: string;
}): JSX.Element {
  const { t, i18n } = useTranslation();
  const presentation = portalErrorPresentation(error, kind);
  useEffect(() => {
    reportPortalError(error, kind, action, targetId ?? null, count, correlationId);
  }, [error, kind, i18n.language, targetId, count, action, correlationId]);
  return (
    <div
      role="alert"
      className="space-y-2 rounded-md border border-destructive/40 p-4 text-sm text-destructive"
    >
      <p>{presentation.message}</p>
      {presentation.reference === undefined ? null : (
        <p className="font-mono text-xs">{presentation.reference}</p>
      )}
      {retry === undefined ? null : (
        <Button type="button" variant="outline" onClick={retry}>
          {t('common.retry')}
        </Button>
      )}
    </div>
  );
}
